import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((storage_provider) => ({
        value: storage_provider.id,
        label: storage_provider.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      try {
        const response = await axios.get(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/storage_provider`, {params})
        if (response.status != 200) {
          return [];
        }

        if (response.data.data == null){
          response.data.data = []
        }

        commit("setData", response.data.data);
        return response.data;

      } catch (error) {
        console.error(error);
      }

    },
    async add(_, params) {
      const { data } = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/storage_provider`, params);

      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/storage_provider/update/${id}`, params);

      return data;
    },
    async delete(_, id) {
      const response = await axios.post(`${window.__env.VUE_APP_FILESYSTEM_URL}/v1/storage_provider/delete/${id}`);

      return response;

    },
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
